import React from "react";
import icon from "../../assets/mirror.png";

export default function ReflectionIcon({ size }) {
  return <img src={icon} width={size} />;
}
